var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutsideTable = function SvgOutsideTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.26266L20.8722 8.6H12.6V22H11.4V8.6H3.12769L12 2.26266ZM6.87225 7.4H17.1277L12 3.73734L6.87225 7.4ZM3.39997 17.0594L2.41162 12.1177L3.58832 11.8823L4.49185 16.4H8.59997V22H7.39997V17.6H4.59997V22H3.39997V17.0594ZM19.5081 16.4L20.4116 11.8823L21.5883 12.1177L20.6 17.0594V22H19.4V17.6H16.6V22H15.4V16.4H19.5081Z"
  })));
};
export default SvgOutsideTable;